// La tabla notas_d2l solo existe en la BD de CEDESCA: no hay selector de sede en
// esta pantalla y siempre se consulta contra esta sede.
export const NOTAS_D2L_HEADQUARTER = 'CEDESCA';

// Máximo que admite el backend por página.
export const PAGE_SIZE = 100;
